/* eslint-disable @typescript-eslint/no-explicit-any */
// NOTE: angular `ErrorHandler` uses `any` in it's public api, therefore we're following the same pattern here

import { ErrorHandler, Inject, Injectable } from '@angular/core';
import { ErrorAppenderService } from './error-appender.service';
import { NG_ERROR_HANDLER } from './ng-error-handler';

@Injectable({
  providedIn: 'root'
})
export class ConsoleErrorAppenderService implements ErrorAppenderService {
  constructor(@Inject(NG_ERROR_HANDLER) private ngErrorHandler: ErrorHandler) {}

  handleError(error: any) {
    if (error?.isError === false) return;

    this.ngErrorHandler.handleError(error);
  }
}
